(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-scummy-bears"] && !Shopify.designMode) return;
  try {
    
  const aboutApplicationFormStyles = `
    section[role="dialog"] {
      width: 100% !important;
      max-width: none !important;
      color: #ffffff !important;
    }

    section[role="dialog"]:has(form[data-testid="form"]) > div:not(:has(form[data-testid="form"])) {
      display: none !important;
    }

    section[role="dialog"] > div:has(form[data-testid="form"]) {
      width: 100% !important;
      max-width: none !important;
      padding: 0 !important;
    }

    [data-form-root][data-current-step]:not([data-current-step="form"]) {
      width: 100% !important;
      color: #ffffff !important;
      font-family: "Roboto Condensed", Arial, sans-serif !important;
    }

    [data-form-root][data-current-step]:not([data-current-step="form"]) section[role="dialog"] {
      box-sizing: border-box !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      justify-content: center !important;
      width: 100% !important;
      min-height: 280px !important;
      padding: 40px !important;
      border: 1px solid rgba(255, 255, 255, 0.2) !important;
      color: #ffffff !important;
      background: #000000 !important;
      text-align: left !important;
    }

    [data-form-root][data-current-step]:not([data-current-step="form"]) section[role="dialog"] > div {
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      padding: 0 !important;
    }

    [data-form-root][data-current-step]:not([data-current-step="form"]) h1,
    [data-form-root][data-current-step]:not([data-current-step="form"]) h2,
    [data-form-root][data-current-step]:not([data-current-step="form"]) h3,
    [data-scummy-form-success] h2 {
      margin: 0 0 16px !important;
      color: #ffffff !important;
      font-family: "Roboto Condensed", Arial, sans-serif !important;
      font-size: clamp(2.25rem, 4vw, 4.5rem) !important;
      font-weight: 900 !important;
      letter-spacing: -0.035em !important;
      line-height: 0.95 !important;
      text-transform: uppercase !important;
    }

    [data-form-root][data-current-step]:not([data-current-step="form"]) p,
    [data-scummy-form-success] p {
      max-width: 34rem !important;
      margin: 0 !important;
      color: rgba(255, 255, 255, 0.72) !important;
      font-family: "Roboto Condensed", Arial, sans-serif !important;
      font-size: 18px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;
    }

    section:has(+ form[data-testid="form"]) {
      display: none !important;
    }

    form[data-testid="form"] {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 20px !important;
      width: 100% !important;
      max-width: none !important;
      font-family: "Roboto Condensed", sans-serif !important;
    }

    form[data-testid="form"],
    form[data-testid="form"] * {
      animation: none !important;
      transition: none !important;
    }

    form[data-testid="form"] > div:has(> shop-lead-capture) {
      display: none !important;
    }

    form[data-testid="form"] > div:has(> input[data-testid^="field-"]),
    form[data-testid="form"] > div:has(> textarea) {
      display: flex !important;
      flex-direction: column !important;
      gap: 0 !important;
      min-width: 0 !important;
    }

    form[data-testid="form"] > div:has(#first_name) {
      order: 1;
    }

    form[data-testid="form"] > div:has(#last_name) {
      order: 2;
    }

    form[data-testid="form"] > div:has(#email) {
      order: 3;
    }

    form[data-testid="form"] > div:has([id="custom#area_of_interest"]) {
      order: 4;
    }

    form[data-testid="form"] > div:has([id="custom#portfolio_or_website"]) {
      order: 5;
      grid-column: 1 / -1 !important;
    }

    form[data-testid="form"] > div:has(input[type="file"]) {
      order: 6;
    }

    form[data-testid="form"] > div:has(textarea) {
      order: 7;
    }

    button[data-testid="btn-form-submit"] {
      order: 8 !important;
    }

    form[data-testid="form"] > div:has(> input[data-testid^="field-"]) > label[for],
    form[data-testid="form"] > div:has(> textarea) > label[for] {
      position: static !important;
      top: auto !important;
      left: auto !important;
      order: -1 !important;
      align-self: stretch !important;
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: none !important;
      margin: 0 0 8px !important;
      color: #ffffff !important;
      background: #000000 !important;
      font-family: "Roboto Condensed", Arial, sans-serif !important;
      font-size: 16px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;
      letter-spacing: normal !important;
      transform: none !important;
    }

    form[data-testid="form"] > div:has(> textarea) > label[for] {
      order: 0 !important;
    }

    form[data-testid="form"] > div:has(> textarea)::before {
      display: none !important;
      content: none !important;
    }

    form[data-testid="form"] input[data-testid^="field-"],
    form[data-testid="form"] textarea {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      min-height: 48px !important;
      margin: 0 !important;
      padding: 0 14px !important;
      border: 1px solid #ffffff !important;
      border-radius: 0 !important;
      color: #202020 !important;
      background: #ffffff !important;
      box-shadow: none !important;
      font-family: "Roboto Condensed", sans-serif !important;
      font-size: 16px !important;
      line-height: 1.5 !important;
    }

    form[data-testid="form"] > div:has(textarea),
    form[data-testid="form"] > div:has(input[type="file"]) {
      grid-column: 1 / -1 !important;
    }

    form[data-testid="form"] textarea {
      -webkit-appearance: none !important;
      appearance: none !important;
      display: block !important;
      height: 140px !important;
      min-height: 140px !important;
      padding: 12px 14px !important;
      background-clip: border-box !important;
      resize: vertical !important;
    }

    form[data-testid="form"] > div:has(input[type="file"]) > p {
      margin: 0 0 8px !important;
      color: #ffffff !important;
      font-family: "Roboto Condensed", sans-serif !important;
      font-size: 16px !important;
      line-height: 1.35 !important;
    }

    form[data-testid="form"] > div:has(input[type="file"]) > div {
      box-sizing: border-box !important;
      width: 100% !important;
      min-height: 72px !important;
      padding: 12px !important;
      border: 1px solid #ffffff !important;
      border-radius: 0 !important;
      background: #ffffff !important;
    }

    button[data-testid="btn-form-submit"] {
      box-sizing: border-box !important;
      grid-column: 1 / -1 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      justify-self: stretch !important;
      width: 100% !important;
      min-height: 54px !important;
      padding: 0 32px !important;
      border: 0 !important;
      border-radius: 0 !important;
      color: #000000 !important;
      background: #fe203a !important;
      font-family: "Roboto Condensed", sans-serif !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      letter-spacing: 0.08em !important;
      line-height: normal !important;
      text-transform: uppercase !important;
    }

    form[data-testid="form"] + div {
      grid-column: 1 / -1 !important;
      color: rgba(255, 255, 255, 0.72) !important;
      font-family: "Roboto Condensed", sans-serif !important;
      text-align: center !important;
    }

    a[data-scummy-policy-link] {
      color: inherit !important;
      text-decoration: underline !important;
      text-underline-offset: 2px !important;
    }

    @media (max-width: 719px) {
      [data-form-root][data-current-step]:not([data-current-step="form"]) section[role="dialog"] {
        min-height: 240px !important;
        padding: 32px 24px !important;
      }

      [data-form-root][data-current-step]:not([data-current-step="form"]) h1,
      [data-form-root][data-current-step]:not([data-current-step="form"]) h2,
      [data-form-root][data-current-step]:not([data-current-step="form"]) h3,
      [data-scummy-form-success] h2 {
        font-size: 2.25rem !important;
      }

      form[data-testid="form"] {
        grid-template-columns: minmax(0, 1fr) !important;
      }

      form[data-testid="form"] > div:has([id="custom#portfolio_or_website"]) {
        grid-column: auto !important;
      }
    }
  `;

  const aboutApplicationFormObservers = new WeakMap();
  const aboutApplicationSuccessTimers = new WeakMap();
  const aboutApplicationCompletedEmbeds = new WeakSet();

  const styleAboutApplicationForm = (formEmbed) => {
    const revealCompletedApplication = () => {
      if (aboutApplicationCompletedEmbeds.has(formEmbed)) {
        return;
      }

      const application = formEmbed.closest('.about-scummy-bears__application');

      if (!application) {
        return;
      }

      aboutApplicationCompletedEmbeds.add(formEmbed);

      if (
        window.location.hash === '#application'
        || window.location.hash === `#${application.id}`
        || window.location.hash.startsWith('#AboutApplication-')
      ) {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }

      const alignApplication = () => application.scrollIntoView({ block: 'start', behavior: 'auto' });

      alignApplication();
      window.requestAnimationFrame(alignApplication);
      window.setTimeout(alignApplication, 300);
    };

    const syncCompletionState = (root) => {
      const formRoot = root.querySelector('[data-form-root]');

      if (!formRoot || formRoot.querySelector('form[data-testid="form"]')) {
        return;
      }

      revealCompletedApplication();
      window.clearTimeout(aboutApplicationSuccessTimers.get(formEmbed));
      const timer = window.setTimeout(() => {
        const dialog = formRoot.querySelector('section[role="dialog"]');

        if (!dialog || formRoot.querySelector('form[data-testid="form"]')) {
          return;
        }

        const fallback = dialog.querySelector('[data-scummy-form-success]');
        const nativeMessage = Array.from(dialog.children)
          .filter((child) => !child.hasAttribute('data-scummy-form-success'))
          .some((child) => child.textContent.trim().length > 0);

        if (nativeMessage) {
          fallback?.remove();
        } else if (!fallback) {
          const message = document.createElement('div');
          const heading = document.createElement('h2');
          const copy = document.createElement('p');

          message.setAttribute('data-scummy-form-success', '');
          heading.textContent = 'APPLICATION RECEIVED.';
          copy.textContent = 'Thanks for reaching out. If it feels like a fit, we’ll be in touch.';
          message.append(heading, copy);
          dialog.appendChild(message);
        }

        dialog.setAttribute('tabindex', '-1');
        dialog.focus({ preventScroll: true });
      }, 250);
      aboutApplicationSuccessTimers.set(formEmbed, timer);
    };

    const addStyles = () => {
      const root = formEmbed.shadowRoot;

      if (!root) {
        return false;
      }

      if (!root.querySelector('[data-scummy-about-form-styles]')) {
        const style = document.createElement('style');
        style.setAttribute('data-scummy-about-form-styles', '');
        style.textContent = aboutApplicationFormStyles;
        root.appendChild(style);
      }

      if (!aboutApplicationFormObservers.has(formEmbed)) {
        const observer = new MutationObserver(() => {
          addStyles();
          syncCompletionState(root);
        });
        observer.observe(root, {
          attributes: true,
          childList: true,
          subtree: true
        });
        aboutApplicationFormObservers.set(formEmbed, observer);
      }

      syncCompletionState(root);

      const form = root.querySelector('form[data-testid="form"]');

      if (!form) {
        return Boolean(root.querySelector('[data-form-root]'));
      }

      if (!form.hasAttribute('data-scummy-field-order')) {
        const orderedFields = [
          form.querySelector(':scope > div:has(#first_name)'),
          form.querySelector(':scope > div:has(#last_name)'),
          form.querySelector(':scope > div:has(#email)'),
          form.querySelector(':scope > div:has([id="custom#area_of_interest"])'),
          form.querySelector(':scope > div:has([id="custom#portfolio_or_website"])'),
          form.querySelector(':scope > div:has(input[type="file"])'),
          form.querySelector(':scope > div:has(textarea)'),
          form.querySelector(':scope > button[data-testid="btn-form-submit"]')
        ];

        orderedFields.filter(Boolean).forEach((field) => form.appendChild(field));
        form.setAttribute('data-scummy-field-order', '');
      }

      const textarea = form.querySelector('textarea');
      const textareaLabel = textarea?.parentElement?.querySelector('label[for]');

      if (!textarea || !textareaLabel) {
        return Boolean(root.querySelector('[data-form-root]'));
      }

      if (!textarea.id && textareaLabel.htmlFor) {
        textarea.id = textareaLabel.htmlFor;
      }

      if (textarea.previousElementSibling !== textareaLabel) {
        textarea.parentElement.insertBefore(textareaLabel, textarea);
      }

      const disclaimer = Array.from(root.querySelectorAll('p')).find(
        (paragraph) => paragraph.textContent.trim() === 'View our privacy policy and terms of service.'
      );

      if (!disclaimer) {
        return true;
      }

      if (!disclaimer.querySelector('[data-scummy-policy-link]')) {
        const privacyLink = document.createElement('a');
        privacyLink.href = '/policies/privacy-policy';
        privacyLink.setAttribute('data-scummy-policy-link', '');
        privacyLink.textContent = 'privacy policy';

        const termsLink = document.createElement('a');
        termsLink.href = '/policies/terms-of-service';
        termsLink.setAttribute('data-scummy-policy-link', '');
        termsLink.textContent = 'terms of service';

        disclaimer.replaceChildren(
          document.createTextNode('View our '),
          privacyLink,
          document.createTextNode(' and '),
          termsLink,
          document.createTextNode('.')
        );
      }

      return true;
    };

    if (addStyles()) {
      return;
    }

    const timer = window.setInterval(() => {
      if (addStyles()) {
        window.clearInterval(timer);
      }
    }, 100);

    window.setTimeout(() => window.clearInterval(timer), 10000);
  };

  const initializeAboutApplicationForms = () => {
    document
      .querySelectorAll('.about-scummy-bears__application-form-slot shopify-forms-embed')
      .forEach(styleAboutApplicationForm);
  };

  const scheduleAboutApplicationForms = () => {
    initializeAboutApplicationForms();

    const timer = window.setInterval(initializeAboutApplicationForms, 250);
    window.setTimeout(() => window.clearInterval(timer), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAboutApplicationForms);
  } else {
    scheduleAboutApplicationForms();
  }

  document.addEventListener('shopify:section:load', scheduleAboutApplicationForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minimal-countdown-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('minimal-countdown-rail')) {
    customElements.define('minimal-countdown-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.timerEnabled !== 'true') return;

        this.timer = this.querySelector('[data-rail-timer]');
        this.days = this.querySelector('[data-rail-days]');
        this.hours = this.querySelector('[data-rail-hours]');
        this.minutes = this.querySelector('[data-rail-minutes]');
        this.seconds = this.querySelector('[data-rail-seconds]');
        this.targetTime = this.getTargetTime();

        this.updateTimer();

        if (!this.classList.contains('is-expired')) {
          this.timerInterval = window.setInterval(() => this.updateTimer(), 1000);
        }
      }

      disconnectedCallback() {
        window.clearInterval(this.timerInterval);
      }

      getTargetTime() {
        const year = Number(this.dataset.year);
        const month = Number(this.dataset.month) - 1;
        const day = Number(this.dataset.day);
        const hour = Number(this.dataset.hour);
        const minute = Number(this.dataset.minute);

        if (this.dataset.timezone !== 'shop') {
          return new Date(year, month, day, hour, minute).getTime();
        }

        const offsetMatch = this.dataset.shopOffset.match(/^([+-])(\d{2})(\d{2})$/);
        let offsetMinutes = 0;

        if (offsetMatch) {
          const direction = offsetMatch[1] === '-' ? -1 : 1;
          offsetMinutes = direction * ((Number(offsetMatch[2]) * 60) + Number(offsetMatch[3]));
        }

        return Date.UTC(year, month, day, hour, minute) - (offsetMinutes * 60000);
      }

      updateTimer() {
        const distance = this.targetTime - Date.now();

        if (!Number.isFinite(this.targetTime) || distance <= 0) {
          this.completeTimer();
          return;
        }

        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        this.days.textContent = String(days).padStart(2, '0');
        this.hours.textContent = String(hours).padStart(2, '0');
        this.minutes.textContent = String(minutes).padStart(2, '0');
        this.seconds.textContent = String(seconds).padStart(2, '0');
        this.timer.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`);
        this.classList.add('is-ready');
      }

      completeTimer() {
        window.clearInterval(this.timerInterval);
        this.classList.add('is-expired', 'is-ready');

        if (this.dataset.expiredAction === 'hide' && !window.Shopify?.designMode) {
          this.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
